module.exports = __webpack_public_path__ + "img/faro-beach-2.918d092c.jpg";